import { Dropdown, DropdownMenuItemType, IDropdownOption, ISelectableOption, TextField } from '@fluentui/react';
import React from 'react';
import {useGetCompaniesQuery, useLazyGetCompanyQuery} from '../../store/Api';
import {ICompany} from "../../models/Company";

interface ICompanyDropdownProps {
    selected?: string;
    onChange: (value: IDropdownOption | undefined) => void;
    required?: boolean;
}

const CompanyDropdown: React.FC<ICompanyDropdownProps> = (props) => {
    const [query, setQuery] = React.useState('')
    const [tempQuery, setTempQuery] = React.useState('')
    const companies = useGetCompaniesQuery({query:{query}});
    const [companyResults, setCompanyResults] = React.useState<ICompany[]>([]);
    const [lazyCompany] = useLazyGetCompanyQuery();
    const [loading, setLoading] = React.useState(false);

    React.useEffect(() => {
        setLoading(true)
        if(props.selected && companies.data && companies.data.items.findIndex(a => a.id === props.selected) === -1 && query === '') {
            lazyCompany(props.selected).then((result) => {
                if(result.data) {
                    setCompanyResults([...companies.data?.items ?? [], result.data])
                }
            });

        }
        else{
            setCompanyResults(companies.data?.items ?? []);
        }
        setLoading(false);
    }, [props.selected, companies.data, query]);


    React.useEffect(() => {
        const timeout = setTimeout(() => {
            if (tempQuery !== query) {
                setQuery(tempQuery)
            }
        }, 500)
        return () => clearTimeout(timeout)
    }, [tempQuery, query])

    const options: IDropdownOption[]  = [
        { key: 'SEARCH', text: 'Search', itemType: DropdownMenuItemType.Header },
        ...companyResults?.map((company) => ({ key: company.id ?? '', text: company.companyName ?? '' })) ?? [],
    ]

    const onRenderOption = (option: ISelectableOption<IDropdownOption> | undefined): JSX.Element => {
        if (option?.itemType === DropdownMenuItemType.Header) {
            return (
                <div style={{padding: '2px 0 2px 0', width: '100%'}}>
                    <TextField
                        value={tempQuery}
                        style={{ width: '100%' }}
                        placeholder='Search...'
                        onChange={(e, newValue) => setTempQuery(newValue ?? '')}
                        />
                </div>
            );
        }
        return (
          <div>
            <span>{option?.text}</span>
          </div>
        );
      };

    return (
        <div>
            <Dropdown
                label='Company'
                selectedKey={props.selected}
                onChange={(e, option) => {
                    props.onChange(option);
                }}
                disabled={loading}
                options={options}
                onRenderOption={onRenderOption}
                required={props.required}
                />
        </div>
    );
}

export default CompanyDropdown;